import { useContextGenerator } from '@lessonup/typescript-core/ui';
import React, { useState } from 'react';

const TopLevelContext = React.createContext<TopLevelClassnameContextProps | undefined>(undefined);

export interface TopLevelClassnameContextProps {
  className: string;
  setClassName: (className: string) => void;
}

export const TopLevelClassnameProvider: React.FC<React.PropsWithChildren> = (props) => {
  const [className, setClassName] = useState<string>('');

  return <TopLevelContext.Provider value={{ className, setClassName }}>{props.children}</TopLevelContext.Provider>;
};

// eslint-disable-next-line react-hooks/rules-of-hooks -- auto-generated TECH-258
export const useTopLevelClassnameContext = useContextGenerator(TopLevelContext, 'TopLevelContext');
